<ng-container [ngSwitch]="provider$ | async">
  <app-e-power *ngSwitchCase="'epower'"></app-e-power>
</ng-container>
